const MINUTE_IN_SECONDS = 60

const THINKING_WORDS = ['Cooking', 'Bleep Blooping', 'Vibing', 'Crunching', 'Discovering']

const FNV_OFFSET_BASIS = 2166136261
const FNV_PRIME = 16777619

/**
 * Picks a thinking label that varies between messages but never changes for a
 * given message id, so renders (and snapshot tests) stay deterministic.
 */
export const getThinkingWord = (messageId: string): string => {
  let hash = FNV_OFFSET_BASIS
  for (let index = 0; index < messageId.length; index++) {
    hash ^= messageId.charCodeAt(index)
    hash = Math.imul(hash, FNV_PRIME)
  }

  return THINKING_WORDS[Math.abs(hash) % THINKING_WORDS.length]
}

export const secondsToTimeString = (seconds: number): string => {
  const minutes = Math.floor(seconds / MINUTE_IN_SECONDS)
  const remainingSeconds = seconds % MINUTE_IN_SECONDS
  if (minutes === 0) {
    return `${remainingSeconds}s`
  }
  if (remainingSeconds === 0) {
    return `${minutes}m`
  }
  return `${minutes}m ${remainingSeconds}s`
}
